module.exports = __webpack_public_path__ + "static/media/queue-white.76e710fd.png";